<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoCrud
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <SelectChequera
                    :model="itemActivo.Id_Chequera"
                    :id_CuentaBancaria="itemActivo.Id_CuentaBancaria"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="seleccionarChequera"
                  />
                </v-flex>
                <v-flex md2 offset-md2>
                  <v-text-field
                    label="Nº*"
                    v-model="itemActivo.Numero"
                    v-mask="'########'"
                    :rules="[rules.requerido]"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md2>
                  <Importe
                    label="Importe"
                    :model="itemActivo.Importe"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="
                      item => (itemActivo.Importe = item.Importe)
                    "
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Destinatario"
                    v-model="itemActivo.Destinatario"
                    persistent-hint
                    :rules="[rules.maximo50]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md2 offset-md2>
                  <Fecha
                    label="Fecha"
                    :fecha="itemActivo.Fecha"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="item => (itemActivo.Fecha = item.Fecha)"
                  />
                </v-flex>
                <v-flex xs6 md2>
                  <Fecha
                    label="Pago"
                    :fecha="itemActivo.FechaPago"
                    :readonly="controlSoloLectura"
                    :sinFechaMaxima="true"
                    @seleccionarItem="
                      item => (itemActivo.FechaPago = item.Fecha)
                    "
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-textarea
                    label="Nota"
                    v-model="itemActivo.Nota"
                    :rules="[rules.maximo500]"
                    persistent-hint
                    :readonly="controlSoloLectura"
                    auto-grow
                    rows="2"
                  ></v-textarea>
                </v-flex>
                <v-flex md1 offset-md4>
                  <v-checkbox
                    label="Anulado"
                    v-model="itemActivo.Anulado"
                    color="red"
                    @change="anular()"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <GrillaCrud
      :activo="grillaActivo"
      :columnas="grillaColumnas"
      :itemsDB="grillaItems"
      :loading="loading"
      @ejecutarAccion="grillaEjecutarAccion"
      @editarItem="grillaEditarItem"
      @borrarItem="grillaBorrarItem"
    />
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import EncabezadoCrud from "@/components/EncabezadoCrud";
import PieCrud from "@/components/PieCrud";
import GrillaCrud from "@/components/GrillaCrud";
import Mensaje from "@/components/Mensaje";
import Fecha from "@/components/Fecha";
import Importe from "@/components/Importe";
import SelectChequera from "@/components/Banco/SelectChequera";
export default {
  name: "ChequeCrud",
  components: {
    EncabezadoCrud,
    PieCrud,
    GrillaCrud,
    Mensaje,
    Fecha,
    Importe,
    SelectChequera
  },
  data() {
    return {
      titulo: "Cheques",
      rutaApi: "Cheque/",
      itemVacio: {
        Id_Cheque: 0,
        Numero: "",
        Fecha: "",
        Id_CuentaBancaria: 0,
        Id_Chequera: 0,
        Destinatario: "",
        Nota: "",
        FechaPago: "",
        Importe: 0,
        Anulado: false
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido",
        maximo15: v => (v || "").length <= 15 || "Máximo 15 caracteres",
        maximo50: v => (v || "").length <= 50 || "Máximo 50 caracteres",
        maximo500: v => (v || "").length <= 500 || "Máximo 500 caracteres"
      },
      grillaColumnas: [
        { text: "Banco", value: "NombreBanco" },
        { text: "Nº", value: "Numero" },
        { text: "Destinatario", value: "Destinatario" },
        { text: "Importe", value: "Importe", mask: "esMoneda" }
      ],
      grillaItems: [],
      grillaActivo: false,
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      controlSoloLectura: true,
      accion: ""
    };
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Nuevo":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = false;
          setTimeout(() => {
            eventBus.$emit("inicializarFecha");
          }, 100);
          eventBus.$emit("setearFocoSelectChequera");
          break;
        case "Guardar":
          if (this.$refs.form.validate())
            this.mostrarMensaje(true, "ConfirmacionGuardar", null, null);
          break;
        case "AceptarConfirmacionGuardar":
          this.guardarItem(this.itemActivo);
          break;
        case "Abrir":
          this.grillaActivo = true;
          this.grillaItems = [];
          break;
        case "Editar":
          this.grillaActivo = false;
          this.controlSoloLectura = false;
          eventBus.$emit("setearFocoSelectChequera");
          break;
        case "Borrar":
          this.grillaActivo = false;
          this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          break;
        case "AceptarConfirmacionBorrar":
          this.borrarItem(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarConfirmacionBorrar":
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.itemActivo = Object.assign({}, this.itemVacio);
          eventBus.$emit("inicializarSelectChequera");
          this.controlSoloLectura = true;
          this.$refs.form.resetValidation();
          break;
      }
    },
    seleccionarChequera(item) {
      this.itemActivo.Id_Chequera = item.Id_Chequera;
      this.itemActivo.Numero = item.NumeroActual;
    },
    anular() {
      if (this.itemActivo.Anulado) {
        this.itemActivo.Importe = 0;
        this.itemActivo.Nota += " [ANULADO]";
      }
    },
    guardarItem(item) {
      this.loading = true;
      HttpHelper.post("Cheque", item)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    borrarItem(item) {
      this.loading = true;
      HttpHelper.delete("Cheque/" + item.Id_Cheque)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEjecutarAccion(accion, textoBuscado) {
      switch (accion) {
        case "Listar":
          this.grillaListarItems(textoBuscado);
          break;
        case "Cerrar":
          this.grillaActivo = false;
          break;
      }
    },
    grillaListarItems(textoBuscado) {
      this.loading = true;
      this.grillaItems = [];
      HttpHelper.get(this.rutaApi, {
        palabra: textoBuscado
      })
        .then(response => {
          this.grillaItems = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEditarItem(item) {
      this.loading = true;
      HttpHelper.get(this.rutaApi, {
        id: item.Id_Cheque
      })
        .then(response => {
          this.itemActivo = Object.assign({}, response.data);
          this.ejecutarAccion("Editar");
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaBorrarItem(item) {
      this.itemActivo = item;
      this.ejecutarAccion("Borrar");
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response == undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
